import { AnimatePresence, motion } from 'framer-motion';

function SaveToast({ isSaving }) {
    return (
        <AnimatePresence>
            {isSaving ?
                <motion.div
                    className='edit-main-page__toast'
                    role="status"
                    aria-live="polite"
                    initial={{ opacity: 0, y: 12, scale: 0.98 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 8, scale: 0.98 }}
                    transition={{ duration: 0.2, ease: 'easeOut' }}
                >
                    <div className='edit-main-page__toast-title'>Идет сохранение</div>
                    <div className='edit-main-page__toast-text'>Не закрывайте страницу, иначе контент сотрется.</div>
                </motion.div>
                : null}
        </AnimatePresence>
    );
}

export default SaveToast;
